<app-bar-chart
  [labels]="labels"
  [series]="series"
  [loading]="isLoading"
  [options]="options"
  [translateLabels]="true"
></app-bar-chart>
